export default "__VITE_ASSET__DSapw3_8__"